import { render, staticRenderFns } from "./ZH.vue?vue&type=template&id=27bb9a3a&scoped=true&"
import script from "./ZH.vue?vue&type=script&lang=js&"
export * from "./ZH.vue?vue&type=script&lang=js&"
import style0 from "./ZH.vue?vue&type=style&index=0&id=27bb9a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb9a3a",
  null
  
)

export default component.exports